import axios from "axios";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

const EndMeetingMessage = () => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const sendDuration = async () => {
      try {
        // Get values from localStorage
        const sessionID = localStorage.getItem("sessionID");
        const duration = localStorage.getItem("duration");
        const meetingType = localStorage.getItem("meetingType");
        const from = localStorage.getItem("from");
        const to = localStorage.getItem("to");

        if (!sessionID || !duration) {
          setTimeout(() => {
            navigate("/");
          }, 500);
          return;
        }

        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/user-session/${sessionID}`,
          { duration: duration, type: meetingType, from: from, to: to },
          {
            headers: {
              lang: i18n.language,
              Authorization: `Bearer ${user?.token}`,
            },
          }
        );
        navigate("/");
        localStorage.removeItem("sessionID");
        localStorage.removeItem("duration");
        localStorage.removeItem("meetingType");
        localStorage.removeItem("from");
        localStorage.removeItem("to");
      } catch (err) {
        console.error("Failed to send meeting duration", err);
      }
    };

    sendDuration();
  }, []);

  return <div></div>;
};

export default EndMeetingMessage;
